import { Service, ServiceCostSummaryHomeCare } from '@anispi-reporting-system/types';
import { Grid } from '@mui/material';
import React, { FunctionComponent } from 'react';

interface Props {
  service: Service;
  serviceCostSummary: ServiceCostSummaryHomeCare;
}

const ResultHomeCare: FunctionComponent<Props> = ({ service, serviceCostSummary }) => {
  const detailInsurance = serviceCostSummary.details.find(({ uploadFileType }) => uploadFileType === 'INSURANCE');
  const detailUninsurance = serviceCostSummary.details.find(({ uploadFileType }) => uploadFileType === 'UNINSURANCE');

  return (
    <Grid container spacing={1} rowSpacing={1} className="text-lg">
      <Grid item xs={4} className="h-12">
        <p>{service === 'HOMECARE-RS' ? 'RS費' : 'RY費'}</p>
      </Grid>
      <Grid item xs={8}>
        <p className="text-right">¥ {serviceCostSummary.serviceCost.toLocaleString()}</p>
      </Grid>
      <Grid item xs={12} className="h-12">
        <p className="text-right">
          {`( ¥ ${detailInsurance?.totalMedicalAmount.toLocaleString()} + ¥ ${detailUninsurance?.totalMedicalAmount.toLocaleString()} ) * ${
            serviceCostSummary.serviceRatio
          } = ¥ ${serviceCostSummary.serviceCost.toLocaleString()}`}
        </p>
      </Grid>
      <Grid item xs={4} className="h-12">
        <p>医療費合計</p>
      </Grid>
      <Grid item xs={8}>
        <p className="text-right">¥ {serviceCostSummary.totalMedicalAmount.toLocaleString()}</p>
      </Grid>
      <Grid item xs={4} className="h-12">
        <p>(保険内 医療費)</p>
      </Grid>
      <Grid item xs={8}>
        <p className="text-right">¥ {detailInsurance?.totalMedicalAmount.toLocaleString()}</p>
      </Grid>
      <Grid item xs={4} className="h-12">
        <p>(保険外 医療費)</p>
      </Grid>
      <Grid item xs={8}>
        <p className="text-right">¥ {detailUninsurance?.totalMedicalAmount.toLocaleString()}</p>
      </Grid>
    </Grid>
  );
};

export { ResultHomeCare };
